import { auditMentionsAuditMentionsDateSchedulesList } from '@mi-front/api-v2';
import { DateStr, GetPntScheduleDto, Paginated } from '@mi-front/core';
import { SelectField } from '@mi-front/ui';
import { Button } from '@mui/material';
import { useField } from 'formik';
import { uniqBy } from 'lodash';
import sortBy from 'lodash/sortBy';
import { FormattedMessage, useIntl } from 'react-intl';

interface Props {
  stationId: string;
}

/**
 * Autocomplete of mention date-schedule names for the manual mention form.
 */
export function MentionFromSchedulesField({ stationId }: Props) {
  const [, , { setValue }] = useField('source');
  const { $t } = useIntl();

  return (
    <SelectField
      label={$t({
        id: 'audit.liveMentionsAdd.mentionFromSchedules',
        defaultMessage: 'Mención desde schedules',
      })}
      name={'mentionSchedules'}
      options={[] as { name: string; description: string }[]}
      getOptionValue={(m: { name: string; description: string }) => m.name}
      getOptionLabel={(m: { name: string; description: string }) => `${m.name} (${m.description})`}
      loadOptions={async () => {
        const page = (await auditMentionsAuditMentionsDateSchedulesList({
          station: stationId,
          // Legacy placeholder date kept until the form wires a real schedule day.
          date: '2023-04-02' as DateStr,
        })) as Paginated<GetPntScheduleDto>;

        return sortBy(
          uniqBy(
            page.results.map((item) => ({
              name: item.customId,
              description: item.name,
            })),
            'name',
          ),
          'name',
        );
      }}
      markRequired
      hint={
        <div>
          <Button
            sx={{ marginLeft: -1.25, marginTop: -0.5 }}
            variant="text"
            size="small"
            onClick={() => setValue('custom')}
          >
            <FormattedMessage
              id="audit.liveMentionsAdd.createCustomMention"
              defaultMessage="Crear una mención custom"
            />
          </Button>
        </div>
      }
    />
  );
}
